import { Button } from "@mui/joy";
import { CheckCircle } from "lucide-react";
import React from "react";
const benefits = [
  "Gain clarity on your life's purpose",
  "Make informed decisions aligned with cosmic energies",
  "Improve relationships through deeper understanding",
  "Discover optimal times for important life events",
  "Unlock your hidden potential and talents",
];

export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-indigo-900">
            Empower Your Journey with Cosmic Wisdom
          </h2>
          <p className="text-xl mb-8 text-gray-600">
            At ProAstrologyReport, we blend ancient astrological knowledge with
            modern insights to provide you with powerful tools for personal
            growth and self-discovery.
          </p>
          <ul className="text-left mb-8">
            {benefits.map((benefit, index) => (
              <li key={index} className="flex items-center mb-3">
                <CheckCircle className="text-green-500 mr-2" />
                <span className="text-gray-700">{benefit}</span>
              </li>
            ))}
          </ul>
          <Button size="lg">Start Your Cosmic Journey</Button>
        </div>
      </div>
    </section>
  );
}
